import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { routes } from 'utils/routeHelper';
import ScrollToTop from 'components/common/ScrollToTop';
import Support from './Support';
import Terms from './Terms';
import Privacy from './Privacy';
import './styles.scss';

const Legal = () => {
  return (
    <div styleName="wrapper">
      <ScrollToTop>
        <Switch>
          <Route path={routes.TERMS_OF_SERVICE} component={Terms} />
          <Route path={routes.PRIVACY_POLICY} component={Privacy} />
          <Route path={routes.SUPPORT} component={Support} />
        </Switch>
      </ScrollToTop>
    </div>
  );
};

export default Legal;
